<template lang="pug">
  .bin-status(:class="[size, $rogue.l10n.lang !== 'en' ? 'wrap' : undefined]")
    .success(v-if="bin.signedUp")
      icon( name="check" fill="green")
      | {{ size !== 'large' ? __('Signed Up') : __('Signed up for Stock Alert') }}
    span.bin-loading(v-else-if="bin.loading && size === 'tiny'") {{ __('Saving...') }}
    span(v-else-if="bin.showEmail") {{ __('Submit') }}
    span(v-else) {{ __('Notify Me') }}
</template>
<script>
export default {
  name  : 'bin-status-text',
  props : {
    size: {
      type    : String,
      default : '',
    },
    bin: {
      type     : Object,
      required : true,
    },
  },
}
</script>
<style lang="scss" scoped>
.bin-status {
  white-space: nowrap;

  &.wrap {
    white-space: normal;
  }

  &.large {
    white-space: normal;
  }
}

.success {
  display: flex;
  justify-content: center;
  align-items: center;

  .icon {
    margin-right: $space-xxs;
  }
}

.bin-status.tiny {
  .icon {
    height: $size-xxs;
    width: $size-xxs;
    margin-right: 4px;
  }
}

.bin-loading {
  color: $color-black-light;
  text-decoration: none;
}

</style>
